angular
  .module 'bookAndPay'
  .controller 'EditCartCtrl', (
    $scope,
    $state,
    $window,
    $http,
    $timeout,
    $stateParams,
    DataService,
    cart
  ) ->
    $scope.cart = cart
    $scope.units = DataService.units
    $scope.currency = DataService.currency

    parseMarketingInformation = ->
      _.mapObject $scope.cart.marketing_information, (field, key) ->
        field.value

    setLinksTarget = ->
      $timeout ->
        angular.element('.privacyPolicies a').each (i, element) ->
          element.target = '_blank'

    if cart.contact_id
      $scope.cart.doPUT(contact_email: $scope.cart.contact_email).then () ->
        $state.go 'bookAndPay.processPayment', uuid: cart.cart_uuid
      , (response) ->
        $scope.isLoading = false
    else
      $http.get("/gyms/#{DataService.gym_id}/privacy_policies?filters[policy_context]=book_and_pay_contact_details").then (response) ->
        $scope.privacyPolicies = response.data.collection
        setLinksTarget()
        $scope.cart.privacy_policy_responses_attributes =
          $scope.privacyPolicies.map (item) ->
            privacy_policy_id: item.id, accepted: false

    isPrivacyPoliciesFormValid = ->
      !$scope.cart.privacy_policy_responses_attributes ||
        _.every $scope.cart.privacy_policy_responses_attributes, (item) ->
          item.accepted

    $scope.cartType = if cart.cart_type is 'payment_only_cart'
      'po'
    else
      undefined

    $scope.marketingInformation = parseMarketingInformation()

    $scope.save = ->
      $scope.cart.marketing_information = buildMarketingInformation()
      $scope.isLoading = true
      $scope.cart.save().then (response) ->
        $state.go 'bookAndPay.processPayment', uuid: cart.cart_uuid
      , (response) ->
        $scope.isLoading = false

    $scope.isFormReady = ->
      !$scope.isLoading &&
      $scope.cart.contact_phone_number &&
      $scope.cart.contact_first_name &&
      $scope.cart.contact_last_name &&
      isPrivacyPoliciesFormValid()

    $scope.displayTime = ->
      moment(cart.event_start_at, 'YYYY/MM/DD HH:mma')
        .format('ddd, D MMM [at] h:mm')

    buildMarketingInformation = ->
      form = {}
      if $scope.cart.marketing_information_form.fields
        $scope.cart.marketing_information_form.fields.forEach (field) ->
          return unless field.on_member
          form[field.id] =
            label: field.label,
            value: $scope.marketingInformation[field.id]
      form

    $scope.cancelBooking = ->
      if $window.confirm "Are you sure you want to cancel your booking?"
        $state.go 'bookAndPay.newCart', uuid: cart.membership_plan_uuid, ct: $scope.cartType
